/**
 * 環境変数の値を配列で取得
 */
export function getEnvAsArray(importMetaEnv: Record<string, unknown>, key: string) {
  const value = importMetaEnv[key]
  if (value) {
    const stringValue = value
    if (typeof stringValue === 'string') {
      return stringValue.split(',')
    }
    return []
  }
  return []
}
